export default [
  {
    path: '/main/reporttemperaturesensordelay',
    meta: {
      tag: 'report_temperature_sensor_delay',
      name: 'Relatório de Atraso Sensor de Temperatura',
      breadcrumb: 'Relatório de Atraso Sensor de Temperatura'
    },
    component: () => import(/* webpackChunkName: "report-temperature-sensor-delay" */ '@/views/main/reports/temperaturesensordelay/Index.vue'),
    children: [
      {
        path: '',
        name: 'listtemperaturesensordelay',
        meta: {
          tag: 'report_temperature_sensor_delay',
          name: 'Relatório de Atraso Sensor de Temperatura',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-temperature-sensor-delay" */ '@/views/main/reports/temperaturesensordelay/List.vue'),
      }
    ]
  }
]
